import type { UserInfo } from '@/netadapters/CloudAdapter'
import { CloudAdapter } from '@/netadapters/CloudAdapter'
import { LoginStatus } from '../Constants'
import { requestCache } from '@core/decorators/RequestCacheDecorator'

class UserInfoManager {
  #userInfo: UserInfo | undefined

  @requestCache()
  async initUserInfo() {
    const adapter = new CloudAdapter()
    const userInfo: UserInfo | undefined = await adapter.getUserInfo()

    if (userInfo && userInfo.loginStatus === LoginStatus.LOGIN_IS_SUCCESS) {
      const userInfoData: UserInfo = {
        avatar: {
          default: userInfo?.avatar?.default,
          personalizationDefault: userInfo?.avatar?.personalizationDefault,
        },
        userName: userInfo?.userName,
        sessionId: userInfo?.sessionId,
        ssoId: userInfo?.ssoId,
        isTrustedClient: userInfo?.isTrustedClient,
      }

      this.#userInfo = userInfoData

      return this.#userInfo
    }
  }

  async getUserInfo() {
    if (this.#userInfo?.userName && this.#userInfo?.avatar?.default) {
      return this.#userInfo
    } else {
      return await this.initUserInfo()
    }
  }

  async isTrustedClient(): Promise<boolean> {
    const userInfo = await this.getUserInfo()

    return !!userInfo?.isTrustedClient
  }

  clear() {
    this.#userInfo = undefined
  }
}
const INSTANCE = new UserInfoManager()

export { INSTANCE }
